import React from 'react';
import { useTranslation } from 'react-i18next';
import { TimeFilter } from '../hooks/useLeaderboard';
import { Button } from '../../../components/ui/button';

interface LeaderboardFiltersProps {
    timeFilter: TimeFilter;
    onChange: (filter: TimeFilter) => void;
}

export const LeaderboardFilters: React.FC<LeaderboardFiltersProps> = ({ timeFilter, onChange }) => {
    const { t } = useTranslation('common');

    return (
        <div className="flex justify-center mb-8">
            <div className="bg-gray-100 p-1 rounded-lg inline-flex">
                {(['all', 'month', 'week'] as const).map((filter) => (
                    <Button
                        key={filter}
                        variant="ghost"
                        onClick={() => onChange(filter)}
                        className={`
                             rounded-md px-6 py-2 h-9 text-sm font-medium transition-all
                             ${timeFilter === filter
                                ? 'bg-white text-blue-600 shadow-sm hover:bg-white'
                                : 'text-gray-500 hover:text-gray-700 hover:bg-gray-200/50'}
                        `}
                    >
                        {t(`leaderboard.filters.${filter}`)}
                    </Button>
                ))}
            </div>
        </div>
    );
};
